import React, { Component, Fragment } from 'react'
import TopNavigation from '../components/TopNavigation/header';
import PageTop from '../components/PageTop/PageTop';
import  VisitorRegistration  from '../components/VisitorRegistration/VisitorRegistration';
import Footer from '../components/Footer/Footer';
import Visitor from '../components/Visitor/Visitor';


export class VisitorPage extends Component {
  render() {
    return (
       <Fragment>
        <TopNavigation></TopNavigation>
             <PageTop pageTitle="Visitor Registrations"></PageTop>
                <VisitorRegistration></VisitorRegistration>
                 <Footer></Footer>
           
           
                </Fragment>
    )
  }
}

export default VisitorPage
